//MapTips_Custom.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as Settings from "../Settings";
import * as Util from "./Util";
import * as Util_App from "./Util_App";

import { Typography } from "@mui/material";

import React from "react";

//Build the map tip.
export function getMapTip(mapTipSetting: Settings.iMapTip, fields: Util_App.iField[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];

   const styles: Default.iStyles = {
      parcels: { maxHeight: 250, maxWidth: 350, overflow: 'auto' },
      default: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
   };

   //Parcels.
   if (mapTipSetting.layerName === "ZZZ Parcels") {
      jsx.push(<div key={Util.uid()} style={styles.parcels} title={mapTipSetting.layerName}>
         {getParcels(fields)}
      </div>);

   } else { //Default map tip.
      jsx.push(<div key={Util.uid()} style={styles.default} title={mapTipSetting.layerName}>
         {getDefault(mapTipSetting, fields)}
      </div>);
   }
   return jsx;
}

//Parcels.
export function getParcels(fields: Util_App.iField[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];
   return jsx;
}

//Show photo in new browser window.
function openImgInNewWindow(url: string) {
   window.open(url, "Picture");
}

//Default map tip.
export function getDefault(mapTipSetting: Settings.iMapTip, fields: Util_App.iField[]): JSX.Element[] {
   const jsx: JSX.Element[] = [];
   let i: number = 0;

   const styles: Default.iStyles = {
      default: { fontWeight: 500 },
   };

   for (const field of fields) {
      if (Settings.security.accessLevel >= field.accessLevel) {
         if (field.value !== "") {
            if (i > 0) {
               jsx.push(<span key={Util.uid()}>&nbsp;&nbsp;&nbsp;</span>);
            }
            jsx.push(<Typography key={Util.uid()} style={styles.default} variant="body2">{field.value}</Typography>);
            i++;
         }
      }
   }
   return jsx;
}
